
import axios from 'axios'
import { Vue, Component } from 'vue-property-decorator'
import moment from 'moment/moment'

@Component({
  components: {}
})

export default class FinancialReportShowDetailsTab extends Vue {
  loading = false

  columns = [
    { title: 'Factuur', key: 'reference', scopedSlots: { customRender: 'reference' } },
    { title: 'Project', key: 'project', scopedSlots: { customRender: 'project' } },
    { title: 'Bouwnummer', key: 'building', scopedSlots: { customRender: 'building' } },
    { title: 'Koper', key: 'customer', scopedSlots: { customRender: 'customer' } },
    { title: 'Geplaatst door', key: 'source', scopedSlots: { customRender: 'source' } },
    { title: 'Geplaatst op', key: 'created_at', scopedSlots: { customRender: 'created_at' } },
    { title: 'Actie\'s', key: 'actions', scopedSlots: { customRender: 'actions' } }
  ]

  invoiceDate = moment()
  invoices = []

  mounted () : void {
    this.getInvoices()
  }

  getInvoices () : void {
    if (!this.invoiceDate) {
      this.invoices = []
      return
    }

    this.loading = true
    axios.post(process.env.VUE_APP_API_URL + '/reports/financial/publishedInvoices', { invoiceDate: moment(this.invoiceDate).format('YYYY-MM-DD') }).then((r) => {
      this.invoices = r.data
    }).finally(() => {
      this.loading = false
    })
  }

  openInvoice (url:string) : void {
    window.open(url, '_blank')
  }

  disabledDates (currentDate: moment.Moment): boolean {
    return currentDate > moment().endOf('day')
  }
}
